import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { GET_OT_TIME_BREAKDOWN_QUERY_KEY } from "../types/CommonTypes";
import { GET_OT_TIME_BREAKDOWN_RESPONSE } from "../types/ResponseTypes";

async function getOtTimeBreackdown(
  tenantId: string,
  hospitalId: string,
  queryString: string
): Promise<GET_OT_TIME_BREAKDOWN_RESPONSE> {
  const { data } = await fetcher({
    url: `analytics/ot-time-breakdown?${queryString}`,
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });

  return data;
}

export default function useGetOtTimeBreakdownQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [
      GET_OT_TIME_BREAKDOWN_QUERY_KEY,
      queryString,
      tenantId,
      hospitalId,
    ],
    queryFn: () => getOtTimeBreackdown(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
}
